const today = new Date();

const initialarray = ["Wake up early", "Start your day", "Add your tasks", "Reach your goals"].map(
  (task, index)=>{
    return {
      id: index+1,
      task,
      date:today.toLocaleString("en-us", {
        day: "numeric",
        month: "short",
        year: "numeric", 
      }),
      time: today.toLocaleString("en-us", {
        hour: "numeric", 
        minute: "numeric"
      })
    } 
  }
)

  const navLinksarray = [
    { label: "HOME", value: "/" },
    { label: "ABOUT", value: "/about" },
    { label: "SIGN IN", value: "/signin" },
  ];

  export {initialarray, navLinksarray};